import { memo, useEffect } from 'react';
import { useNavigation } from '@bonanza-social/navigation';
import { useTranslation } from 'react-i18next';
import InviteFriendsComponent from '../components/InviteFriendsComponent';
function InviteFriendsScreen() {
  const navigation = useNavigation();
  const { t } = useTranslation('inviteFriends');

  useEffect(() => {
    navigation.setOptions({ title: t('inviteFriendsTitle') });
  }, [navigation, t]);

  return <InviteFriendsComponent />;
}

export default memo(InviteFriendsScreen);
